import { SnackbarFunctionProps } from '@lyearn/ui';
import {
  PublishContentConfig,
  QuestionInput,
  QuizSectionInput,
  UpdateQuestionEntity,
  UpdateQuizInput,
} from '@/types/schema';

export enum QuizCreatorActionsEnum {
  UpdateQuiz = 'UPDATE_QUIZ',
  PublishQuiz = 'PUBLISH_QUIZ',
  AddQuestions = 'ADD_QUESTIONS',
  UpdateQuestion = 'UPDATE_QUESTION',
  RemoveQuestion = 'REMOVE_QUESTION',
  ReorderQuestion = 'REORDER_QUESTION',
  DuplicateQuestion = 'DUPLICATE_QUESTION',
  SetSelectedQuestion = 'SET_SELECTED_QUESTION',
  PublishDialog = 'PUBLISH_DIALOG',
  SetIsOfDifferentWorkspace = 'SET_IS_OF_DIFFERENT_WORKSPACE',
  AddSection = 'ADD_SECTION',
  RemoveSection = 'REMOVE_SECTION',
  UpdateSection = 'UPDATE_SECTION',
  ReorderSection = 'REORDER_SECTION',
  MoveQuestionToSection = 'MOVE_QUESTION_TO_SECTION',
}

export interface PublishQuizAction {
  type: QuizCreatorActionsEnum.PublishQuiz;
  payload: { publishConfig?: PublishContentConfig; snackbarProps: SnackbarFunctionProps };
}

interface PublishDialogAction {
  type: QuizCreatorActionsEnum.PublishDialog;
}

interface UpdateQuizAction {
  type: QuizCreatorActionsEnum.UpdateQuiz;
  payload: {
    quiz: Omit<UpdateQuizInput, 'id'>;
    snackbarProps?: SnackbarFunctionProps;
  };
}

interface AddQuestionsAction {
  type: QuizCreatorActionsEnum.AddQuestions;
  payload: {
    questions: QuestionInput[];
  };
}

interface UpdateQuestionAction {
  type: QuizCreatorActionsEnum.UpdateQuestion;
  payload: {
    question: UpdateQuestionEntity;
  };
}

interface RemoveQuestionAction {
  type: QuizCreatorActionsEnum.RemoveQuestion;
  payload: {
    index: number;
  };
}

interface ReorderQuestionAction {
  type: QuizCreatorActionsEnum.ReorderQuestion;
  payload: {
    fromIndex: number;
    toIndex: number;
  };
}

interface DuplicateQuestionAction {
  type: QuizCreatorActionsEnum.DuplicateQuestion;
  payload: {
    index: number;
  };
}

interface SetSelectedQuestionAction {
  type: QuizCreatorActionsEnum.SetSelectedQuestion;
  payload: {
    index: number;
  };
}

interface SetIsOfDifferentWorkspaceAction {
  type: QuizCreatorActionsEnum.SetIsOfDifferentWorkspace;
}

interface AddSectionAction {
  type: QuizCreatorActionsEnum.AddSection;
  payload: {
    name: string;
  };
}

interface RemoveSectionAction {
  type: QuizCreatorActionsEnum.RemoveSection;
  payload: {
    sectionId: string;
  };
}

interface UpdateSectionAction {
  type: QuizCreatorActionsEnum.UpdateSection;
  payload: {
    sectionId: string;
    updates: Partial<QuizSectionInput>;
  };
}

interface ReorderSectionAction {
  type: QuizCreatorActionsEnum.ReorderSection;
  payload: {
    fromIndex: number;
    toIndex: number;
  };
}

interface MoveQuestionToSectionAction {
  type: QuizCreatorActionsEnum.MoveQuestionToSection;
  payload: {
    questionId: string;
    sectionId: string | null;
    toIndex?: number;
  };
}

export type QuizCreatorActions =
  | PublishQuizAction
  | UpdateQuizAction
  | AddQuestionsAction
  | UpdateQuestionAction
  | RemoveQuestionAction
  | ReorderQuestionAction
  | DuplicateQuestionAction
  | SetSelectedQuestionAction
  | SetIsOfDifferentWorkspaceAction
  | PublishDialogAction
  | AddSectionAction
  | RemoveSectionAction
  | UpdateSectionAction
  | ReorderSectionAction
  | MoveQuestionToSectionAction;

export type onQuizCreatorAction = (action: QuizCreatorActions) => void;
